const rankNames = {
  '4': '4', '5': '5', '6': '6', '7': '7',
  'Q': 'Dama', 'J': 'Valete', 'K': 'Rei', 'A': 'Ás', '2': '2', '3': '3',
}
const suitNames = {
  ouros: 'Ouros', espadas: 'Espadas', copas: 'Copas', paus: 'Paus',
}

export default function PlayerHand({ cards, disabled, onPlayCard }) {
  return (
    <div id="player-hand" aria-label="Suas cartas">
      <h3>Suas cartas</h3>
      <div id="cards-container" className="cards-container">
        {cards.map((card, index) => {
          const name = `${rankNames[card.rank] || card.rank} de ${suitNames[card.suit] || card.suit}`
          const cardKey = `${card.rank}-${card.suit}`
          return (
            <button
              key={cardKey}
              type="button"
              className="card-btn"
              aria-label={`Jogar ${name}, carta ${index + 1} de ${cards.length}`}
              disabled={disabled}
              onClick={() => onPlayCard(index)}
            >
              {name}
            </button>
          )
        })}
      </div>
    </div>
  )
}
